// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.site-header {
  background-color: #0000006b;
  color: #383838;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  z-index: 1000;
}
.site-header .button.red {
  width: 5rem;
  height: 5rem;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.site-header .top-bar {
  display: flex;
  flex-direction: row;
  height: 10rem;
  width: 100%;
  align-items: center;
}
.site-header .top-bar .panel {
  display: flex;
  align-items: center;
  margin: 0 3.2rem;
}
.site-header .top-bar .panel.right {
  justify-content: right;
}
.site-header .top-bar .panel.right,
.site-header .top-bar .panel.left {
  flex-basis: 50%;
}
.site-header .bottom-bar {
  display: flex;
  flex-direction: row;
  padding: 0 1.4rem;
  width: 100%;
}
.site-header .options {
  position: absolute;
  top: 90%;
}
.site-header .logo {
  vertical-align: middle;
  box-sizing: content-box;
  height: 5rem;
}
.site-header .flex-spacer {
  flex-grow: 1;
  flex-basis: 100%;
  justify-content: center;
  display: flex;
}
.site-header .header-rows {
  display: flex;
  flex-direction: column;
  margin-right: 1rem;
}
.site-header .header-rows .client-row {
  display: flex;
  justify-content: center;
  position: relative;
}
.site-header .header-rows h4 {
  color: #e84230;
  background: linear-gradient(360deg, #B2005D -14.55%, #D50D43 10.45%, #F62925 45.01%, #FFAE00 109.71%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
}
.site-header .user-part a {
  color: #ffffff;
  text-decoration: none;
  cursor: pointer;
}
.site-header .user-part > * {
  padding-left: 1.8rem;
}
.site-header .back-button {
  cursor: pointer;
  width: 4rem;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  transition-duration: 0.25s;
  border-radius: 5px;
}
.site-header .back-button:hover {
  background-color: #eeeeee;
}
.site-header .back-button.hidden {
  padding-right: 0;
  width: 0;
}
.site-header .search-bar {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eeeeee;
  gap: 1rem;
}
.site-header .search-wrapper .search-input {
  background-color: transparent;
  flex-grow: 1;
  padding: 0.8rem 1rem;
}
.site-header .search-icon-wrapper {
  width: 4rem;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.site-header .client-list {
  width: 50%;
  display: flex;
  max-height: 70vh;
  padding: 1rem;
  flex-direction: column;
}
.site-header .search-wrapper {
  flex-grow: 1;
  border: 1px solid #eeeeee;
  border-radius: 2rem;
  box-shadow: 3px 3px 8px inset rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.site-header .client-list .option {
  flex-basis: 50%;
  width: 50%;
  box-sizing: border-box;
}
.site-header .client-list .content-wrapper {
  overflow: auto;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.header-links {
  align-items: center;
  font-size: 1.2rem;
}
.header-links .spacer {
  height: 2rem;
  margin: 0 1.4rem;
  width: 0.2rem;
  display: inline-block;
  background-color: #e84230;
}
.sub-button-container {
  display: flex;
  align-items: center;
}
.map-icon {
  width: 2.4rem;
  height: 2.4rem;
}
.map-icon img {
  width: 1.6rem;
  height: 1.6rem;
}
.site-header .open-ticket {
  position: absolute;
}
.site-header .options.hide {
  display: none;
}
.site-header .options.hide {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./views/shared/Header/SiteHeader.less"],"names":[],"mappings":"AAEA;EACE,2BAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;AADF;AAIA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFF;AAKA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;AAHF;AAMA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAJF;AAOA;EACE,sBAAA;AALF;AAQA;;EAEE,eAAA;AANF;AASA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AAPF;AAUA;EACE,kBAAA;EACA,QAAA;AARF;AAWA;EACE,sBAAA;EACA,uBAAA;EACA,YAAA;AATF;AAYA;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;AAVF;AAaA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AAXF;AAcA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;AAZF;AAeA;EACE,cAAA;EACA,qGAAA;EACA,6BAAA;EACA,oCAAA;EACA,kBAAA;AAbF;AAgBA;EACE,cAAA;EACA,qBAAA;EACA,eAAA;AAdF;AAiBA;EACE,oBAAA;AAfF;AAkBA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;AAhBF;AAmBA;EACE,yBAAA;AAjBF;AAoBA;EACE,gBAAA;EACA,QAAA;AAlBF;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;EACA,SAAA;AAnBF;AAsBA;EACE,6BAAA;EACA,YAAA;EACA,oBAAA;AApBF;AAuBA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AArBF;AAwBA;EACE,UAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAtBF;AAyBA;EACE,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,iDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAvBF;AA0BA;EACE,eAAA;EACA,UAAA;EACA,sBAAA;AAxBF;AA2BA;EACE,cAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;AAzBF;AA4BA;EACE,mBAAA;EACA,iBAAA;AA1BF;AA6BA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;AA3BF;AA8BA;EACE,aAAA;EACA,mBAAA;AA5BF;AA+BA;EACE,aAAA;EACA,cAAA;AA7BF;AAgCA;EACE,aAAA;EACA,cAAA;AA9BF;AAiCA;EACE,kBAAA;AA/BF;AAkCA;EACE,aAAA;AAhCF;AAmCA;EACI,aAAA;AAjCJ","sourcesContent":["@import '../../../styles/colours.less';\n\n.site-header {\n  background-color: #0000006b;\n  color: #383838;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n  position: relative;\n  z-index: 1000;\n}\n\n.site-header .button.red {\n  width: 5rem;\n  height: 5rem;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.site-header .top-bar {\n  display: flex;\n  flex-direction: row;\n  height: 10rem;\n  width: 100%;\n  align-items: center;\n}\n\n.site-header .top-bar .panel {\n  display: flex;\n  align-items: center;\n  margin: 0 3.2rem;\n}\n\n.site-header .top-bar .panel.right {\n  justify-content: right;\n}\n\n.site-header .top-bar .panel.right,\n.site-header .top-bar .panel.left {\n  flex-basis: 50%;\n}\n\n.site-header .bottom-bar {\n  display: flex;\n  flex-direction: row;\n  padding: 0 1.4rem;\n  width: 100%;\n}\n\n.site-header .options {\n  position: absolute;\n  top: 90%;\n}\n\n.site-header .logo {\n  vertical-align: middle;\n  box-sizing: content-box;\n  height: 5rem;\n}\n\n.site-header .flex-spacer {\n  flex-grow: 1;\n  flex-basis: 100%;\n  justify-content: center;\n  display: flex;\n}\n\n.site-header .header-rows {\n  display: flex;\n  flex-direction: column;\n  margin-right: 1rem;\n}\n\n.site-header .header-rows .client-row {\n  display: flex;\n  justify-content: center;\n  position: relative;\n}\n\n.site-header .header-rows h4 {\n  color: #e84230;\n  background: @vertical-gradient;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  text-align: center;\n}\n\n.site-header .user-part a {\n  color: #ffffff;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.site-header .user-part > * {\n  padding-left: 1.8rem;\n}\n\n.site-header .back-button {\n  cursor: pointer;\n  width: 4rem;\n  height: 4rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition-duration: 0.25s;\n  border-radius: 5px;\n}\n\n.site-header .back-button:hover {\n  background-color: #eeeeee;\n}\n\n.site-header .back-button.hidden {\n  padding-right: 0;\n  width: 0;\n}\n\n.site-header .search-bar {\n  display: flex;\n  align-items: center;\n  margin-bottom: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #eeeeee;\n  gap: 1rem;\n}\n\n.site-header .search-wrapper .search-input {\n  background-color: transparent;\n  flex-grow: 1;\n  padding: 0.8rem 1rem;\n}\n\n.site-header .search-icon-wrapper {\n  width: 4rem;\n  height: 4rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.site-header .client-list {\n  width: 50%;\n  display: flex;\n  max-height: 70vh;\n  padding: 1rem;\n  flex-direction: column;\n}\n\n.site-header .search-wrapper {\n  flex-grow: 1;\n  border: 1px solid #eeeeee;\n  border-radius: 2rem;\n  box-shadow: 3px 3px 8px inset rgb(0 0 0 / 12%);\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.site-header .client-list .option {\n  flex-basis: 50%;\n  width: 50%;\n  box-sizing: border-box;\n}\n\n.site-header .client-list .content-wrapper {\n  overflow: auto;\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.header-links {\n  align-items: center;\n  font-size: 1.2rem;\n}\n\n.header-links .spacer {\n  height: 2rem;\n  margin: 0 1.4rem;\n  width: 0.2rem;\n  display: inline-block;\n  background-color: #e84230;\n}\n\n.sub-button-container {\n  display: flex;\n  align-items: center;\n}\n\n.map-icon {\n  width: 2.4rem;\n  height: 2.4rem;\n}\n\n.map-icon img {\n  width: 1.6rem;\n  height: 1.6rem;\n}\n\n.site-header .open-ticket {\n  position: absolute;\n}\n\n.site-header .options.hide {\n  display: none;\n}\n\n.site-header .options.hide {\n    display:none\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
